import React from 'react';

import { StyleSheet } from 'react-native';

import { InnerLayout, LayoutContainer } from 'components/layout/styled';
import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const ProductSelectionsContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productSelectionsContainer, style]} />
);

export const ProductHomeInnerLayout = InnerLayout.withConfig<{ $isFullContainer?: boolean }>(
  ({ $isFullContainer }) => ({
    paddingY: 0,
    marginY: 0,
    ...($isFullContainer && { padding: 0, margin: 0 }),
  })
);

export const ProductHomeLayoutContainer = LayoutContainer.withConfig({
  marginY: 0,
  paddingY: 0,
});

export const ProductInformationSection = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.productInformationSection,
        isDesktop && styles.productInformationSectionDesktop,
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  productInformationSection: {
    marginVertical: 16,
  },
  productInformationSectionDesktop: {
    marginVertical: 32,
  },
  productSelectionsContainer: {
    width: '100%',
  },
});
